import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const GoogleProductSelectionPage = lazy(
  () => import('~/features/content-enrichment/pages/google-product-selection-page'),
);

/** Product selection step for the Google Ads scheduled enrichment flow.
 *  URL: `/enrichments/google/product-selection`. Contract-gated via the parent layout. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/product-selection',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <GoogleProductSelectionPage />
    </Suspense>
  ),
});
